<style>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}

.required_err {
  color: rgba(255, 0, 0);
}

.elevation-1 tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .03) !important;
}

.br {
    color: rgba(109, 103, 164);
}

</style>

<template>
<div>
    <div class="br_section"><h2 class="br">Save configuration</h2></div>
    <ValidationObserver ref="observer" v-slot="{ invalid }">
        <ValidationProvider v-slot="{ errors }">
            <span>The default configuration file name is used if the value is omitted. </span>
            <span>The configuration file will be saved in {{ default_dir }} directory.</span>
            <v-text-field
                v-model="config_file_name"
                label="Configuration file name (optional)">
            </v-text-field>
            <span class="required_err">{{ errors[0] }}</span>
        </ValidationProvider>
    </ValidationObserver>

    <v-textarea
        v-bind:readonly="true"
        label="Save log"
        v-model="save_log">
    </v-textarea>

    <v-toolbar flat>
        <span class="msg_ok">{{ ok_msg_text }}</span>
        <span class="msg_err">{{ err_msg_text }}</span>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" :disabled="invalid"
                text @click="save()">
            Save
        </v-btn>
    </v-toolbar>
</div>
</template>
  
<script>

import api_client from '../services/api.js';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { ValidationProvider, extend } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';

import "../validation_rules.js";

export default {
name: "sysctl",
components: { 
    Treeselect, ValidationProvider, ValidationObserver,
},
data: () => ({
    save_log: '',
    ok_msg_text: '',
    err_msg_text: '',
    config_file_name: '',
    default_dir: '/etc/bisonrouter/',
}),

watch: {
},

created() {
    this.initialize()
},

methods: {
    clear_msgs() {
        this.ok_msg_text = "";
        this.err_msg_text = "";
    },

    initialize() {
    },

    close() {
        this.dialog = false;
        this.$nextTick(() => {
            this.edited_index = -1;
        });
    },

    save() {
        let data = {};
        if (this.config_file_name.trim() != '') {
            data["file_name"] = this.default_dir + this.config_file_name.trim();
        }

        api_client.run_post_query('/utils/save_config', data)
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
            }
            else {
                this.save_log = '';
                response.data.output.forEach(item => {
                    this.save_log += "\n" + item.msg
                });
                this.err_msg_text = "";
                this.ok_msg_text = "Configuration file successfully saved.";
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
    },
}

};
</script>
